export const TypingIndicator = () => {
  return (
    <div className="typing-indicator bg-light">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
};
